<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0" cols="12">
        <span class="text-uppercase page-subtitle d-block">Orçamentos</span>
        <h3 class="page-title d-inline">Editar</h3>
        <router-link class="btn btn-success text-white float-right" :to="{ name: 'admin-quotation-new' }">Novo orçamento</router-link>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="card-small mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
              <d-col cols="12" lg="8" class="text-right" v-if="quotation">
                <quotation-buttons :quotation="quotation"></quotation-buttons>
              </d-col>
            </d-row>
          </d-card-header>

          <quotation-form ref="quotationForm"/>
        </d-card>
      </d-col>
    </d-row>
    <import-modals/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import QuotationForm from '_modules/quotation/components/QuotationForm.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import { MODEL, _LOAD_MODEL_ } from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-edit',
  components: {
    ImportModals,
    QuotationForm,
    QuotationButtons,
  },
  computed: {
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        Events.$emit(_LOAD_MODEL_, quotation);
        return quotation;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotation',
    ]),
    getQuotationModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotation(parseInt(this.$route.params.quotationId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.quotationForm.save();
    },
  },
  mounted() {
    if (this.$route.params.quotationId) {
      this.getQuotationModel();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
